import styles from "./testimonialcard.module.css";
import { Ratings } from "../../shared";
const TestimonialCard = ({ testimonial }) => {
  const { name, desc, imageUrl, rating ,title ,designation} = testimonial;
  return (
    <div className={styles.testimonial__card}>  
      <div className={styles.testimonial__image}>
        <img src={imageUrl} alt={name} />
      </div>
      <div className={styles.testimonial__content}>
       
         <h4 className={styles.name}>{name}</h4>
            <h3 className={styles.designation}>{designation}</h3>
        <p className={styles.desc}>{desc}</p>
        <div className={styles.rating}>
          <Ratings rating={rating} /> 
        </div>
     
      </div>
    </div>
  );
};
export default TestimonialCard;